// ChatDefaultRenderer.jsx
import React from 'react';
import PropTypes from 'prop-types';

import UniversalContainer from '../component/UniversalContainer.jsx';

export const ChatDefaultRenderer = ({ isOnDesktop, hasChatroom, isAuthed }) => {
  if (isOnDesktop) {
    if (hasChatroom && isAuthed) {
      return <UniversalContainer filename="DesktopChatDefault" />;
    } else {
      return (
        <UniversalContainer
          filename="GridDiscoverUsers"
          withChatLink
          size={104}
          marginTop={13}
        />
      );
    }
  } else {
    return <UniversalContainer filename="Chatrooms" />;
  }
};

ChatDefaultRenderer.propTypes = {
  hasChatroom: PropTypes.bool,
  isOnDesktop: PropTypes.bool,
  isAuthed: PropTypes.bool,
};

ChatDefaultRenderer.defaultProps = {
  hasChatroom: false,
  isOnDesktop: false,
  isAuthed: false,
};

export default ChatDefaultRenderer;
